import { useTheme } from '@mui/material/styles';
import Drawer from '@mui/material/Drawer';
import FilerListTable from './components/FilerListTable';
import { alpha, Box, Button, IconButton } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';

interface Props {
  onClose: () => void;
  onHide: () => void;
  open: boolean;
  variant: 'permanent' | 'persistent' | 'temporary' | undefined;
}

const FilerListSidebar = ({ open, variant, onClose, onHide }: Props): JSX.Element => {
  
  const theme = useTheme();

  return (
    <Drawer
      anchor="left"
      onClose={() => onClose()}
      open={open}
      variant={variant}
      sx={{
        '& .MuiPaper-root': {
          width: '100%',
          maxWidth: {xl: '275px', lg: '250px', md: '300px', xs: '250px'},
          top: { xs: 0, md: 75 },
          height: '100%',
          background: theme.palette.alternate.main,
        },
      }}
    >
       <Box alignItems={'center'} marginTop={2}>
          <IconButton 
            aria-label="Hide Filer Listing" 
            onClick={onHide} 
            title="Hide Filer Listing"
            sx={{ marginLeft: 2 }}>
            <MenuIcon />
          </IconButton>
        </Box>
        <FilerListTable onClose={onClose} isFullTable={false} />
    </Drawer>
  );
};

export default FilerListSidebar;
